import { useMutation } from "@tanstack/react-query";
import { mfaLogin, requestMFAToken, resendSmsToken, updateSubscriberPhoneNumber, verifySMSToken } from "../UpsellPanelService";

export const useMFALoginMutation = () => {
    return useMutation({
        mutationFn: async (model) => await mfaLogin(model)
    });
}
export const useRequestMFATokenMutation = () => {
    return useMutation({
        mutationFn: async (email) => await requestMFAToken(email)
    });
}
export const useUpdateSubscriberPhoneNumberMutation = () => {
    return useMutation({
        mutationFn: async (mobile) => await updateSubscriberPhoneNumber(mobile)
    });
}
export const useResendSMSTokenMutation = () => {
    return useMutation({
        mutationFn: async (mobile) => await resendSmsToken(mobile)
    });
}
export const useVerifySMSTokenMutation = () => {
    return useMutation({
        mutationFn: async (model) => await verifySMSToken(model)
    });
}